export default __webpack_public_path__ + "static/media/ShiftsClosed.ae7333d6.svg";